import React from 'react'
import ResellerMap from './ResellerMap'

const Resellers = () => <ResellerMap />

export default Resellers
